import {
	CHARACTERISTICS_OF_RESPONDENTS_AND_HOUSEHOLDS,
	DAILY_DISASTER_PREPARATION,
	LOSSES_FROM_THE_CHISHANG_EARTHQUAKE,
	WHAT_PEOPLE_DID_AFTER_THE_CHISHANG_EARTHQUAKE,
} from "../constants";

export const themeData = [
	{
		title: DAILY_DISASTER_PREPARATION,
		description:
			"本調查探討花東地區居民在地震發生前的準備情況，包括防災知識的獲取、防災手冊的認知、住宅安全的評估，以及日常防震措施（如固定家具、準備防災包、規劃避難路線）。此外，也關注家庭內部是否有避難計畫討論，以及居民對政府地震應變指引的理解程度。研究結果將有助於評估居民的減災意識與行動落實狀況，進一步提升社會的災害應變能力。",
	},
	{
		title: WHAT_PEOPLE_DID_AFTER_THE_CHISHANG_EARTHQUAKE,
		description:
			"本調查記錄0918池上地震發生當下，民眾所處的位置與當下的應變行為，並進一步分析震後避難行動，包括是否選擇離家避難、避難地點與過夜情況。透過這些數據，將能更清楚瞭解地震發生時，居民對於災害的即時應對方式，並分析哪些因素影響民眾的行動決策，以優化未來的防災教育與應變措施。",
	},
	{
		title: LOSSES_FROM_THE_CHISHANG_EARTHQUAKE,
		description:
			"本調查關注0918池上地震所帶來的實際損失，包括個人與家庭成員的身心影響、房屋與家具的受損程度，以及基礎設施（如水電供應）的中斷狀況。此外，也調查民眾因停水、停電而產生的額外花費，評估地震對居民日常生活與經濟負擔的影響。這些數據將有助於釐清地震衝擊的範圍與嚴重程度，為未來災害復原與補償政策提供依據。",
	},
	{
		title: CHARACTERISTICS_OF_RESPONDENTS_AND_HOUSEHOLDS,
		description:
			"為了更全面地理解地震對不同家庭的影響，本調查亦收集受訪者的基本人口與家戶特徵，包括家庭成員結構（如幼兒、高齡者、身心障礙者的分布）、家戶收入、房屋類型、屋齡與居住時間等資訊。這些資料將有助於分析不同社會群體的防災需求，並評估地震對不同族群造成的影響，以作為未來防災規劃與資源配置的參考依據。",
	},
];

export const topicKeyExcelFileNameMapping = {
	"1-10": "1_10民眾日常的減災整備_是否加強住宅結構.xlsx",
	"1-11": "1_11民眾日常的減災整備_是否規劃避難路線.xlsx",
	"1-12": "1_12民眾日常的減災整備_是否參與地震應變演練.xlsx",
	"1-13": "1_13民眾日常的減災整備_是否購買住宅地震保險.xlsx",
	"1-1": "1_1民眾日常的減災整備_撤避難知識的來源.xlsx",
	"1-2": "1_2民眾日常的減災整備_是否知道防災手冊.xlsx",
	"1-3": "1_3民眾日常的減災整備_結構是否安全.xlsx",
	"1-4": "1_4民眾日常的減災整備_是否知道趴下、掩護、穩住.xlsx",
	"1-5": "1_5民眾日常的減災整備_是否和家人討論如何避難 .xlsx",
	"1-6": "1_6民眾日常的減災整備_可接受之避難處所距離.xlsx",
	"1-7": "1_7民眾日常的減災整備_是否有準備防災包.xlsx",
	"1-8": "1_8民眾日常的減災整備_不準備防災包的理由.xlsx",
	"1-9": "1_9民眾日常的減災整備_是否固定家具.xlsx",
	"2-1": "2_1遇到池上地震！民眾都做了甚麼 _地震時在哪 個縣市鄉鎮.xlsx",
	"2-2":
		"2_2遇到池上地震！民眾都做了甚麼 _地震時在室 內、室外還是交通工具上.xlsx",
	"2-4": "2_4遇到池上地震！民眾都做了甚麼 _地震了！民眾立即的反應.xlsx",
	"2-5": "2_5遇到池上地震！民眾都做了甚麼 _地震後的避難行為-是否有離家.xlsx",
	"2-6": "2_6遇到池上地震！民眾都做了甚麼 _地震後的避難行為-避難地點.xlsx",
	"2-7~2-9":
		"2_7~2_9遇到池上地震！民眾都做了甚麼 _地震後的避難行為-是否過夜.xlsx",
	"3-1": "3_1池上地震導致的損失_損失類型.xlsx",
	"3-2": "3_2池上地震導致的損失_停水時間長.xlsx",
	"3-3": "3_3池上地震導致的損失_停水損失.xlsx",
	"3-4": "3_4池上地震導致的損失_停電時間長.xlsx",
	"3-5": "3_5池上地震導致的損失_停電損失.xlsx",
	"3-6": "3_6池上地震導致的損失_建物損失.xlsx",
	"4-10": "4_10受訪者及家戶特徵_受訪者年齡 .xlsx",
	"4-11": "4_11受訪者及家戶特徵_教育程度 .xlsx",
	"4-12": "4_12受訪者及家戶特徵_是否為原住民.xlsx",
	"4-1~4-4": "4_1~4_4受訪者及家戶特徵_戶內人口狀態.xlsx",
	"4-5": "4_5受訪者及家戶特徵_家戶收入.xlsx",
	"4-6": "4_6受訪者及家戶特徵_建物構造.xlsx",
	"4-7": "4_7受訪者及家戶特徵_屋齡.xlsx",
	"4-8": "4_8受訪者及家戶特徵_居住時間.xlsx",
	"4-9": "4_9受訪者及家戶特徵_受訪者性別 .xlsx",
};

export const chartImageZoomRatio = {
	"1-2": 0.7,
	"1-3": 0.7,
	"1-5": 0.7,
	"2-2": 0.7,
	"2-5": 0.7,
	"2-7~2-9": 0.7,
	"4-6": 0.7,
	"4-7": 0.7,
	"4-9": 0.5,
	"4-11": 0.7,
	"4-12": 0.7,
};

export const topicsData = require("./topicsData.json");
